import globals from '../../globlas';
import { _sendWithAxios, _sendWithAxiosBlob } from '../api';

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API

export const criarPermissao = async (data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Permissao/criar-permissao`, 'POST', data);
}

export const obterPermissaoInfo = async (idPermissao) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Permissao/obter-permissao/${idPermissao}`, 'GET');
}  

export const editarPermissao = async (idPermissao,data) => {
  return await _sendWithAxios(`${REACT_APP_URL_BASE_API}Permissao/editar-permissao/${idPermissao}`, 'POST',data);
} 